import { api } from "./api";

export const getListRegion = (listRegionId: string) => {
  return api.get(`/list-regions/${listRegionId}`);
};
